import React from "react";

import type { SettingModule } from "@app/analytics/account/types";
import { PartialBy } from "@app/common/types";

import Stack, { StackProps } from "@rui/Stack";

import SettingsHeader from "./SettingsHeader";
import { SettingsModuleCard } from "./styles";

type SettingsModuleProps = StackProps &
  PartialBy<SettingModule, "id" | "active">;

const SettingsModule = ({
  active,
  id,
  title,
  children,
  sx,
  ...props
}: SettingsModuleProps) => {
  return (
    <SettingsModuleCard
      data-scroll-id={id}
      active={active}
      elevation={active ? 1 : 0}
    >
      <SettingsHeader active={Boolean(active)} title={title} id={id} />
      <Stack sx={{ px: 1, py: 2, ...sx }} spacing={2} {...props}>
        {children}
      </Stack>
    </SettingsModuleCard>
  );
};

export default SettingsModule;
